import { IFlatOptionListValue } from "../../contracts/base/option-lists/option-list-value";
import OptionListValueBase from "../../contracts/base/option-lists/option-list-value-base";

export default class FlatOptionListValue extends OptionListValueBase implements IFlatOptionListValue {}

export { FlatOptionListValue };
